import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import TechnicalErrorPage from 'views/TechnicalErrorPage';
import config from 'Config';
import Header from 'components/Header';
import PrivacyPolicyFooterWidget from 'components/widgets/PrivacyPolicyFooterWidget';
import ContactUs from 'components/ContactUs';

const StyledErrorPage = styled.div`
  position: relative;
  max-width: ${({ theme }) => theme.breakpoints.md}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing * 2}px;
  padding-top:${({ theme }) => theme.spacing * 4}px;
  background-color: ${({ theme }) => theme.palette.background.secondary};

  .PrivacyPolicyFooterWidget {
    margin-top: ${({ theme }) => theme.spacing * 4}px;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  render() {
    const { state, props } = this;

    if (state.error) {
      // You can render any custom fallback UI
      const { customerServicePhoneNumber } = config;
      return (
        <>
          <Header
            logoWrapper={{ elementType: 'a', elementProps: { href: config.brandWebsiteUrl, target: '_blank' } }}
          />
          <StyledErrorPage>
            <TechnicalErrorPage
              errorName={state.error.name}
              customerServicePhoneNumber={customerServicePhoneNumber}
            />

            <ContactUs
              customerServicePhoneNumber={customerServicePhoneNumber}
            />
            <PrivacyPolicyFooterWidget />
          </StyledErrorPage>
        </>
      );
    }

    return props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ErrorBoundary;
